export default __webpack_public_path__ + "static/media/event-faq-sl.1b03d0bf.jpg";